var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "countdown-timer" },
    [
      _c("loader", {
        staticClass: "loader",
        attrs: { big: true, success: _vm.success, "is-responsive": false }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "timer", class: { success: _vm.success } }, [
        _c("small", [_vm._v("tempo restante")]),
        _vm._v("\n    " + _vm._s(_vm._f("secondsToTime")(_vm.seconds)) + "\n  ")
      ]),
      _vm._v(" "),
      _c("h1", [_vm._v("Finalize sua limpeza")])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5cf555e0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cf555e0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PurchaseFlow/Steps/CheckoutPopup/Countdown.vue
// module id = null
// module chunks = 